var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import styled from 'styled-components';
import { Box } from 'pcln-design-system';
import { useAccordionState } from './AccordionProvider';
var CollapsibleSection = styled(Box)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  max-height: ", ";\n  height: 100%;\n  overflow: hidden;\n\n  ", "\n"], ["\n  max-height: ", ";\n  height: 100%;\n  overflow: hidden;\n\n  ", "\n"])), function (_a) {
    var open = _a.open;
    return (open ? '100vh' : 0);
}, function (_a) {
    var shouldAnimate = _a.shouldAnimate;
    return (shouldAnimate ? 'transition: max-height 0.4s;' : null);
});
var AccordionContent = function (_a) {
    var children = _a.children, className = _a.className, props = __rest(_a, ["children", "className"]);
    var _b = useAccordionState(), open = _b.open, shouldAnimate = _b.shouldAnimate, shouldMapOpenPropToContent = _b.shouldMapOpenPropToContent;
    return (React.createElement(CollapsibleSection, { open: open, shouldAnimate: shouldAnimate, className: className, "data-testid": 'CollapsibleSection', "aria-hidden": !open },
        React.createElement(Box, __assign({}, props), shouldMapOpenPropToContent
            ? React.Children.map(children, function (child) {
                return React.cloneElement(child, {
                    isAccordionOpen: open,
                });
            })
            : children)));
};
export default AccordionContent;
var templateObject_1;
//# sourceMappingURL=AccordionContent.js.map